import React from "react"
import WithChildren from "../models/interfaces"

export function Row({ children, className }: RowProps) {
    const classnames = "row " + (className || "")
    return <div className={classnames}>{children}</div>
}

export interface RowProps extends WithChildren {
    className?: string
}
